const features = [
    {
      icon: (<svg style={{ fill: "currentColor" }} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 31.178 31.178"
        >
     <g>
       <g>
         <circle cx="5.042" cy="5.721" r="3.866"/>
         <path style={{ fill: "currentColor" }} d="M30.779,6.78h-9.346V5.722h-2.479V6.78h-8.877H9.446v1.275h0.631v2.806l-1.452-0.692H6.449l-1.474,1.709l-1.426-1.709
           l-3.133,0.582l-0.2,6.949h1.328l0.072,1.443h0.202v0.879v0.649v6.884H1.551L0,27.893v1.43h1.321l1.542-0.251l0.014,0.251h1.708
           v-1.593v-0.173v-6.883h0.973v6.883v0.173v1.593h1.708l0.014-0.251l1.542,0.251h1.321v-1.43L8.59,27.557H8.325v-6.883v-0.65v-0.879
           H8.57l0.316-6.4l1.191,0.539v7.355h9.136v2.343l-5.042,5.688h1.812l3.404-3.844v3.844h1.041v-3.84l3.399,3.84h1.841l-5.07-5.688
           v-2.343h10.182V8.056h0.398V6.78H30.779z M29.887,19.7h-9.291h-1.383H10.97v-6.013l3.717,1.682l-0.014-2.317l-3.703-1.765V8.056
           h18.917V19.7z"/>
       </g>
     </g>
     </svg>),
      title: "Instructor-led Sessions",
      description: "Live instructor-led classes 5 sessions in a week of 4 hours each",
    },
    {
      icon: (
        <svg fill="#000000" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg">
  
        <g id="ICON">
        <path style={{ fill: "currentColor" }} d="M35.596,48.159l-2.631,9.822c-0.114,0.424 0.063,0.873 0.435,1.106c0.372,0.233 0.853,0.196 1.185,-0.091l3.731,-3.231c0,0 1.616,4.663 1.616,4.663c0.143,0.411 0.535,0.683 0.97,0.673c0.434,-0.011 0.813,-0.301 0.935,-0.719l1.673,-5.708l1.652,5.705c0.121,0.418 0.499,0.71 0.935,0.721c0.435,0.012 0.828,-0.26 0.971,-0.672l1.616,-4.663c-0,0 3.731,3.231 3.731,3.231c0.332,0.287 0.813,0.324 1.185,0.091c0.372,-0.233 0.549,-0.682 0.435,-1.106l-2.631,-9.822c1.919,-1.981 3.101,-4.68 3.101,-7.654c-0,-6.074 -4.931,-11.005 -11.005,-11.005c-6.074,-0 -11.005,4.931 -11.005,11.005c0,2.974 1.182,5.673 3.101,7.654Zm1.689,1.426l-1.545,5.765l2.383,-2.063c0.251,-0.217 0.593,-0.296 0.914,-0.21c0.32,0.086 0.577,0.325 0.686,0.639c-0,-0 1.075,3.101 1.075,3.101l1.572,-5.365c-1.874,-0.191 -3.609,-0.854 -5.085,-1.867Zm12.43,0c-1.468,1.008 -3.194,1.669 -5.056,1.864l1.549,5.352l1.069,-3.085c0.109,-0.314 0.366,-0.553 0.686,-0.639c0.321,-0.086 0.663,-0.007 0.914,0.21c-0,0 2.383,2.063 2.383,2.063l-1.545,-5.765Zm-46.715,-15.585l0,15c-0,0.796 0.316,1.559 0.879,2.121c0.562,0.563 1.325,0.879 2.121,0.879c6.483,-0 26.5,-0 26.5,-0c0.552,0 1,-0.448 1,-1c0,-0.552 -0.448,-1 -1,-1c0,-0 -20.017,-0 -26.5,-0c-0.265,0 -0.52,-0.105 -0.707,-0.293c-0.188,-0.187 -0.293,-0.442 -0.293,-0.707l0,-15c0,-0.552 -0.448,-1 -1,-1c-0.552,-0 -1,0.448 -1,1Zm0,-28l0,24c0,0.552 0.448,1 1,1c0.552,-0 1,-0.448 1,-1l0,-18l30,-0c0.552,-0 1,-0.448 1,-1c-0,-0.552 -0.448,-1 -1,-1l-30,-0c0,0 -0,-4 -0,-4c0,-0.552 0.448,-1 1,-1c0,0 51.5,0 51.5,0c0.552,0 1,0.448 1,1c0,0 0,4 0,4c0,-0 -19.5,-0 -19.5,-0c-0.552,-0 -1,0.448 -1,1c-0,0.552 0.448,1 1,1l19.5,-0l-0,37c-0,0.552 -0.448,1 -1,1l-2.5,-0c-0.552,0 -1,0.448 -1,1c0,0.552 0.448,1 1,1l2.5,-0c1.657,0 3,-1.343 3,-3l0,-43c-0,-1.657 -1.343,-3 -3,-3l-51.5,0c-1.657,0 -3,1.343 -3,3Zm40.5,25.5c4.97,0 9.005,4.035 9.005,9.005c-0,4.97 -4.035,9.005 -9.005,9.005c-4.97,-0 -9.005,-4.035 -9.005,-9.005c0,-4.97 4.035,-9.005 9.005,-9.005Zm-14.5,13.5l-0,-2c-0,-1.657 -1.343,-3 -3,-3l-14,-0c-1.657,-0 -3,1.343 -3,3l0,2c0,1.657 1.343,3 3,3l14,0c1.657,0 3,-1.343 3,-3Zm15.374,-12.127c-0.176,-0.317 -0.511,-0.514 -0.874,-0.514c-0.363,0 -0.698,0.197 -0.874,0.514l-1.979,3.559c-0,0 -3.997,0.783 -3.997,0.783c-0.356,0.07 -0.646,0.327 -0.758,0.672c-0.113,0.346 -0.029,0.724 0.218,0.99l2.774,2.982c-0,0 -0.491,4.043 -0.491,4.043c-0.044,0.36 0.111,0.716 0.405,0.93c0.293,0.213 0.68,0.25 1.009,0.097l3.693,-1.716c0,0 3.693,1.716 3.693,1.716c0.329,0.153 0.716,0.116 1.009,-0.097c0.294,-0.214 0.449,-0.57 0.405,-0.93l-0.491,-4.043c0,0 2.774,-2.982 2.774,-2.982c0.247,-0.266 0.331,-0.644 0.218,-0.99c-0.112,-0.345 -0.402,-0.602 -0.758,-0.672l-3.997,-0.783c0,0 -1.979,-3.559 -1.979,-3.559Zm-17.374,10.127l-0,2c-0,0.552 -0.448,1 -1,1l-14,0c-0.552,0 -1,-0.448 -1,-1c-0,-0 0,-2 0,-2c0,-0.552 0.448,-1 1,-1l14,-0c0.552,-0 1,0.448 1,1Zm16.5,-7.583l1.331,2.394c0.143,0.257 0.393,0.438 0.682,0.495l2.688,0.526c-0,0 -1.866,2.006 -1.866,2.006c-0.2,0.215 -0.295,0.509 -0.26,0.801l0.33,2.719c0,-0 -2.484,-1.154 -2.484,-1.154c-0.267,-0.124 -0.575,-0.124 -0.842,-0l-2.484,1.154c-0,-0 0.33,-2.719 0.33,-2.719c0.035,-0.292 -0.06,-0.586 -0.26,-0.801l-1.866,-2.006c0,0 2.688,-0.526 2.688,-0.526c0.289,-0.057 0.539,-0.238 0.682,-0.495l1.331,-2.394Zm-33.5,1.583l18.5,-0c0.552,0 1,-0.448 1,-1c0,-0.552 -0.448,-1 -1,-1l-18.5,-0c-0.552,0 -1,0.448 -1,1c0,0.552 0.448,1 1,1Zm0,-4l21,0c0.552,0 1,-0.448 1,-1c0,-0.552 -0.448,-1 -1,-1l-21,0c-0.552,0 -1,0.448 -1,1c0,0.552 0.448,1 1,1Zm0,-4l23,0c0.552,0 1,-0.448 1,-1c0,-0.552 -0.448,-1 -1,-1l-23,0c-0.552,0 -1,0.448 -1,1c0,0.552 0.448,1 1,1Zm0,-4l43,0c0.552,0 1,-0.448 1,-1c0,-0.552 -0.448,-1 -1,-1l-43,0c-0.552,0 -1,0.448 -1,1c0,0.552 0.448,1 1,1Zm0,-4l43,0c0.552,0 1,-0.448 1,-1c0,-0.552 -0.448,-1 -1,-1l-43,-0c-0.552,0 -1,0.448 -1,1c0,0.552 0.448,1 1,1Zm9,-4l25.5,0c0.552,-0 1,-0.448 1,-1c-0,-0.552 -0.448,-1 -1,-1l-25.5,0c-0.552,-0 -1,0.448 -1,1c-0,0.552 0.448,1 1,1Zm-11,-10.5c0.552,-0 1,0.448 1,1c0,0.552 -0.448,1 -1,1c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1Zm4,-0c0.552,-0 1,0.448 1,1c0,0.552 -0.448,1 -1,1c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1Zm4,-0c0.552,-0 1,0.448 1,1c0,0.552 -0.448,1 -1,1c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1Z"/>
        
        </g>
        
        </svg>
      ),
        title: "Certifications",
        description:
          "Get 15 certifications in one course: Advance Excel, Financial Modeling and Equity Research, Financial Planning and Analysis, Investment Banking, Power BI, NCFM and NISM.",
      },
    {
      
      icon:(<svg style={{ fill: "currentColor" }} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 56 56">
     <g>
       <g>
       </g>
       <g>
         <path style={{ fill: "currentColor" }} d="M12,24c3.309,0,6-2.691,6-6s-2.691-6-6-6s-6,2.691-6,6S8.691,24,12,24z M12,14c2.206,0,4,1.794,4,4s-1.794,4-4,4
           s-4-1.794-4-4S9.794,14,12,14z"/>
         <path style={{ fill: "currentColor" }} d="M44,24c3.309,0,6-2.691,6-6s-2.691-6-6-6s-6,2.691-6,6S40.691,24,44,24z M44,14c2.206,0,4,1.794,4,4s-1.794,4-4,4
           s-4-1.794-4-4S41.794,14,44,14z"/>
         <path style={{ fill: "currentColor" }} d="M54,26v13c0,1.654-1.346,3-3,3V31c0-2.757-2.243-5-5-5h-5c-0.552,0-1,0.448-1,1v4v1v1h-8c-0.552,0-1,0.448-1,1v3h-6v-3
           c0-0.552-0.448-1-1-1h-8v-1v-1v-4c0-0.552-0.448-1-1-1h-5c-2.757,0-5,2.243-5,5v11c-1.654,0-3-1.346-3-3V26H0v13
           c0,2.045,1.237,3.802,3,4.576V56h2V44h1h1h8v11c0,0.552,0.448,1,1,1h3h1h1v-1V40v-1h3h8h3v1v15v1h1h1h3c0.552,0,1-0.448,1-1V44h8
           h1h1v12h2V43.576c1.763-0.774,3-2.531,3-4.576V26H54z M20,37h-2h-6v-6h-2v7c0,0.552,0.448,1,1,1h7c0.551,0,1,0.449,1,1v14h-2V43
           c0-0.552-0.448-1-1-1H7V31c0-1.654,1.346-3,3-3h4v3v1v2c0,0.552,0.448,1,1,1h8v2H20z M40,42c-0.552,0-1,0.448-1,1v11h-2V40
           c0-0.551,0.449-1,1-1h7c0.552,0,1-0.448,1-1v-7h-2v6h-6h-2h-3v-2h8c0.552,0,1-0.448,1-1v-2v-1v-3h4c1.654,0,3,1.346,3,3v11H40z"/>
         <path style={{ fill: "currentColor" }} d="M19,10v3c0,0.431,0.275,0.812,0.684,0.949C19.788,13.983,19.895,14,20,14c0.309,0,0.607-0.144,0.8-0.4l2.7-3.6H31
           c1.654,0,3-1.346,3-3V3c0-1.654-1.346-3-3-3H19c-1.654,0-3,1.346-3,3v4C16,8.654,17.346,10,19,10z M18,3c0-0.551,0.449-1,1-1h12
           c0.551,0,1,0.449,1,1v4c0,0.551-0.449,1-1,1h-8c-0.315,0-0.611,0.148-0.8,0.4L21,10V9c0-0.552-0.448-1-1-1h-1
           c-0.551,0-1-0.449-1-1V3z"/>
         <rect x="20" y="4" width="10" height="2"/>
         <rect x="27" y="25" width="6" height="2"/>
         <path style={{ fill: "currentColor" }} d="M26,21c-1.654,0-3,1.346-3,3v4c0,1.654,1.346,3,3,3h8c1.654,0,3-1.346,3-3v-0.697l1.832-2.748
           c0.205-0.307,0.224-0.701,0.05-1.026C38.708,23.203,38.369,23,38,23h-1.171c-0.413-1.164-1.525-2-2.829-2H26z M35,24
           c0,0.552,0.448,1,1,1h0.131l-0.963,1.445C35.059,26.609,35,26.803,35,27v1c0,0.551-0.449,1-1,1h-8c-0.551,0-1-0.449-1-1v-4
           c0-0.551,0.449-1,1-1h8C34.551,23,35,23.449,35,24z"/>
         <rect x="23" y="16" width="2" height="2"/>
         <rect x="27" y="16" width="2" height="2"/>
         <rect x="31" y="16" width="2" height="2"/>
       </g>
     </g>
     </svg>),
      title: "Interview Preparation",
      description:
        "Prepare you for the Financial Analyst interview process in any top-notch global Finance firm.",
    },
    {
      icon: (<svg style={{ fill: "currentColor" }} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  
        viewBox="0 0 480 480">
     <g>
       <g>
         <path style={{ fill: "currentColor" }} d="M413.648,74.336L341.664,2.352C340.216,0.896,338.216,0,336,0H104C81.944,0,64,17.944,64,40v344c0,22.056,17.944,40,40,40
           h88v56h16v-56h120c4.416,0,8-3.576,8-8v-40c0-14.88,10.216-27.432,24-30.984V416v64h16v-56c22.056,0,40-17.944,40-40V80
           C416,77.784,415.104,75.784,413.648,74.336z M344,27.312L388.688,72H344V27.312z M400,384c0,13.232-10.768,24-24,24v-72
           c0-4.424-3.584-8-8-8c-26.472,0-48,21.528-48,48v32H104c-13.232,0-24-10.768-24-24V40c0-13.232,10.768-24,24-24h224v64
           c0,4.424,3.584,8,8,8h64V384z"/>
       </g>
     </g>
     <g>
       <g>
         <path style={{ fill: "currentColor" }} d="M224,48H112c-4.416,0-8,3.576-8,8v112c0,4.424,3.584,8,8,8h32h48h32c4.416,0,8-3.576,8-8V56C232,51.576,228.416,48,224,48
           z M184,160h-32v-16c0-8.824,7.176-16,16-16c8.824,0,16,7.176,16,16V160z M160,104c0-4.416,3.592-8,8-8s8,3.584,8,8s-3.592,8-8,8
           S160,108.416,160,104z M216,160h-16v-16c0-10.488-5.136-19.72-12.952-25.56c3.064-4.032,4.952-9,4.952-14.44
           c0-13.232-10.768-24-24-24s-24,10.768-24,24c0,5.44,1.888,10.408,4.952,14.44C141.136,124.28,136,133.512,136,144v16h-16V64h96
           V160z"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="248" y="72" width="40" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="248" y="104" width="48" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="312" y="104" width="40" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="248" y="136" width="104" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="144" y="200" width="64" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="224" y="200" width="48" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="288" y="200" width="80" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="112" y="232" width="64" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="192" y="232" width="128" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="336" y="232" width="32" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="112" y="264" width="32" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="160" y="264" width="96" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="272" y="264" width="96" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="112" y="296" width="32" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="160" y="296" width="96" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="272" y="296" width="96" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="112" y="328" width="72" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="200" y="328" width="112" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="112" y="360" width="32" height="16"/>
       </g>
     </g>
     <g>
       <g>
         <rect x="160" y="360" width="136" height="16"/>
       </g>
     </g>
     </svg>),
      title: "Resume Preparation & Job Portal Updation",
      description:
        "Prepare you for the Financial Analyst interview process in any top-notch global Finance firm.",
    },
    {
      icon: (
        <svg style={{ fill: "currentColor" }} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" 
   viewBox="0 0 496 496">
  <g>
  <g>
    <g>
      <path style={{ fill: "currentColor" }} d="M407.312,348l14.344-14.344l-11.312-11.312L396,336.688l-15.096-15.096C393.032,299.76,400,274.688,400,248
        c0-2.28-0.24-4.496-0.344-6.752C437.248,232.408,464,199.128,464,160h-16c0,30.896-20.624,57.32-49.904,65.192
        C387.032,152.184,324.04,96,248,96c-2.28,0-4.496,0.24-6.752,0.344C232.408,58.752,199.128,32,160,32v16
        c30.896,0,57.32,20.624,65.192,49.904C152.184,108.968,96,171.96,96,248c0,2.28,0.24,4.496,0.344,6.752
        C58.752,263.592,32,296.872,32,336h16c0-30.896,20.624-57.32,49.904-65.192C108.968,343.816,171.96,400,248,400
        c26.688,0,51.76-6.968,73.584-19.096L336.68,396l-14.344,14.344l11.312,11.312l14.344-14.344L424.4,483.72
        c7.92,7.92,18.456,12.28,29.656,12.28C477.184,496,496,477.184,496,454.064c0-11.2-4.36-21.736-12.28-29.656L407.312,348z
         M248,112c68.24,0,124.728,50.56,134.384,116.16l-15.768,2.624C358.232,172.76,308.312,128,248,128
        c-0.408,0-0.808,0.056-1.216,0.064l-2.64-15.864C245.44,112.16,246.696,112,248,112z M248,144c57.344,0,104,46.656,104,104
        s-46.656,104-104,104s-104-46.656-104-104S190.656,144,248,144z M112,248c0-68.24,50.56-124.728,116.16-134.384l2.624,15.768
        C172.76,137.768,128,187.688,128,248c0,0.408,0.056,0.808,0.064,1.216l-15.864,2.64C112.16,250.56,112,249.304,112,248z M248,384
        c-68.24,0-124.728-50.56-134.384-116.16l15.768-2.624C137.768,323.24,187.688,368,248,368c66.168,0,120-53.832,120-120
        c0-0.408-0.056-0.808-0.064-1.216l15.864-2.64c0.04,1.296,0.2,2.552,0.2,3.856C384,322.992,322.992,384,248,384z M335.44,372.128
        c14.224-10.048,26.64-22.464,36.688-36.688l12.56,12.56L348,384.688L335.44,372.128z M454.064,480
        c-6.928,0-13.448-2.696-18.344-7.592L359.312,396L396,359.312l76.408,76.408c4.896,4.896,7.592,11.416,7.592,18.344
        C480,468.368,468.368,480,454.064,480z"/>
      <path style={{ fill: "currentColor" }} d="M424,144c39.704,0,72-32.296,72-72S463.704,0,424,0c-39.704,0-72,32.296-72,72S384.296,144,424,144z M448,122.52
        c-7.288,3.472-15.408,5.48-24,5.48c-8.592,0-16.712-2.008-24-5.48V112c0-13.232,10.768-24,24-24s24,10.768,24,24V122.52z M408,56
        c0-8.824,7.176-16,16-16c8.824,0,16,7.176,16,16s-7.176,16-16,16C415.176,72,408,64.824,408,56z M424,16
        c30.872,0,56,25.128,56,56c0,15.256-6.152,29.088-16.08,39.2c-0.272-13.448-7.144-25.312-17.568-32.36
        C452.288,73.032,456,64.952,456,56c0-17.648-14.352-32-32-32s-32,14.352-32,32c0,8.952,3.712,17.032,9.648,22.84
        c-10.432,7.056-17.304,18.912-17.568,32.36C374.152,101.088,368,87.256,368,72C368,41.128,393.128,16,424,16z"/>
      <path style={{ fill: "currentColor" }} d="M72,144c39.704,0,72-32.296,72-72S111.704,0,72,0S0,32.296,0,72S32.296,144,72,144z M96,122.52
        c-7.288,3.472-15.408,5.48-24,5.48s-16.712-2.008-24-5.48V112c0-13.232,10.768-24,24-24s24,10.768,24,24V122.52z M56,56
        c0-8.824,7.176-16,16-16s16,7.176,16,16s-7.176,16-16,16S56,64.824,56,56z M72,16c30.872,0,56,25.128,56,56
        c0,15.256-6.152,29.088-16.08,39.2c-0.272-13.448-7.144-25.312-17.568-32.36C100.288,73.032,104,64.952,104,56
        c0-17.648-14.352-32-32-32S40,38.352,40,56c0,8.952,3.712,17.032,9.648,22.84C39.224,85.896,32.352,97.752,32.08,111.2
        C22.152,101.088,16,87.256,16,72C16,41.128,41.128,16,72,16z"/>
      <path style={{ fill: "currentColor" }} d="M72,352c-39.704,0-72,32.296-72,72c0,39.704,32.296,72,72,72s72-32.296,72-72C144,384.296,111.704,352,72,352z
         M96,474.52c-7.288,3.472-15.408,5.48-24,5.48s-16.712-2.008-24-5.48V464c0-13.232,10.768-24,24-24s24,10.768,24,24V474.52z
         M56,408c0-8.824,7.176-16,16-16s16,7.176,16,16c0,8.824-7.176,16-16,16S56,416.824,56,408z M111.92,463.2
        c-0.272-13.448-7.144-25.312-17.568-32.36C100.288,425.032,104,416.952,104,408c0-17.648-14.352-32-32-32s-32,14.352-32,32
        c0,8.952,3.712,17.032,9.648,22.84c-10.424,7.056-17.296,18.912-17.568,32.36C22.152,453.088,16,439.256,16,424
        c0-30.872,25.128-56,56-56s56,25.128,56,56C128,439.256,121.848,453.088,111.92,463.2z"/>
      <path style={{ fill: "currentColor" }} d="M160,232v40v8v8h176v-8v-8v-72h-48v72h-16V168h-48v104h-16v-40H160z M304,216h16v56h-16V216z M240,184h16v88h-16V184z
         M192,272h-16v-24h16V272z"/>
    </g>
  </g>
  </g>
  </svg>
      ),
      title: "Real-time Case Studies",
      description:
        "Live case studies for each financial topic to ensure that learners can understand it thoroughly.",
    },
    {
      icon: (
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.94 47.94" style={{ fill: "currentColor" }}><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path style={{ fill: "currentColor" }} d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757 c2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042 c0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685 c-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528 c-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956 C22.602,0.567,25.338,0.567,26.285,2.486z"></path> </g></svg>
      ),
      title: "Lifetime Access",
      description:
        "You get Lifetime access to the FINXL LMS, which includes videos, Excel Spreadsheets, Financial Models, Presentations, eBooks, Quizzes and case studies.",
    },
    {
      icon: (<svg fill="#000000" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
        <path style={{ fill: "currentColor" }} d="M1468.214 0v564.698h-112.94V112.94H112.94v1694.092h1242.334v-225.879h112.94v338.819H0V0h1468.214Zm129.428 581.311c22.137-22.136 57.825-22.136 79.962 0l225.879 225.879c22.023 22.023 22.023 57.712 0 79.848l-677.638 677.637c-10.616 10.504-24.96 16.49-39.98 16.49h-225.88c-31.17 0-56.469-25.299-56.469-56.47v-225.88c0-15.02 5.986-29.364 16.49-39.867Zm-155.291 314.988-425.895 425.895v146.031h146.03l425.895-425.895-146.03-146.03Zm-764.714 346.047v112.94H338.82v-112.94h338.818Zm225.88-225.88v112.94H338.818v-112.94h564.697Zm734.106-315.44-115.424 115.425 146.03 146.03 115.425-115.423-146.031-146.031ZM1129.395 338.83v451.758H338.82V338.83h790.576Zm-112.94 112.94H451.759v225.878h564.698V451.77Z" fill-rule="evenodd"/>
    </svg>),
      title: "Assignments",
      description: "Each session will be followed by a Practical assignment.",
    },
    {
      icon: (<svg style={{ fill: "currentColor" }} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  
        viewBox="0 0 496 496" >
     <g>
       <g>
         <g>
           <path style={{ fill: "currentColor" }} d="M432,336h-10.84c16.344-13.208,26.84-33.392,26.84-56v-32c0-30.872-25.128-56-56-56h-32c-2.72,0-5.376,0.264-8,0.64V48
             h16V0H0v48h16v232H0v48h187.056l40,80H304v88h192v-96C496,364.712,467.288,336,432,336z M422.584,371.328l-32.472,13.92
             L412.28,352h5.472L422.584,371.328z M358.944,352h34.112L376,377.576L358.944,352z M361.872,385.248l-32.472-13.92L334.24,352
             h5.472L361.872,385.248z M432.008,280C432,310.872,406.872,336,376,336s-56-25.128-56-56h37.424
             c14.12,0,27.392-5.504,37.368-15.48l4.128-4.128c8.304,10.272,20.112,16.936,33.088,18.92V280z M48,192v72h107.176
             c0.128,0.28,0.176,0.584,0.312,0.856L163.056,280H32V48h304v149.48c-18.888,9.008-32,28.24-32,50.52v32h-65.064l-24.816-46.528
             C208.368,222.696,197.208,216,185,216c-10.04,0-18.944,4.608-25,11.712V192H48z M144,208v40H64v-40H144z M360,208h32
             c22.056,0,40,17.944,40,40v15.072c-9.168-2.032-17.32-7.48-22.656-15.48l-8.104-12.152l-17.768,17.768
             c-6.96,6.96-16.208,10.792-26.048,10.792H320v-16C320,225.944,337.944,208,360,208z M16,16h336v16H16V16z M16,312v-16h155.056
             l8,16H16z M256,392h-19.056L169.8,257.712c-1.176-2.36-1.8-4.992-1.8-7.608V249c0-9.376,7.624-17,17-17c6.288,0,12.04,3.456,15,9
             l56,104.992V392z M247.464,296h58.392c1.28,5.616,3.232,10.968,5.744,16H256L247.464,296z M264.536,328h57.952
             c2.584,2.872,5.352,5.568,8.36,8H268.8L264.536,328z M480,480h-32v-32h32V480z M480,432h-32v-32h-16v80H320v-88h-48v-40h45.76
             l-7.168,28.672L376,408.704l65.416-28.032l-7.144-28.56C459.68,353.312,480,374.296,480,400V432z"/>
           <path style={{ fill: "currentColor" }} d="M160,128v-16h-16.808c-1.04-5.096-3.072-9.832-5.856-14.024l11.92-11.92l-11.312-11.312l-11.92,11.92
             c-4.192-2.784-8.928-4.816-14.024-5.856V64H96v16.808c-5.096,1.04-9.832,3.072-14.024,5.856l-11.92-11.92L58.744,86.056
             l11.92,11.92c-2.784,4.192-4.816,8.928-5.856,14.024H48v16h16.808c1.04,5.096,3.072,9.832,5.856,14.024l-11.92,11.92
             l11.312,11.312l11.92-11.92c4.192,2.784,8.928,4.816,14.024,5.856V176h16v-16.808c5.096-1.04,9.832-3.072,14.024-5.856
             l11.92,11.92l11.312-11.312l-11.92-11.92c2.784-4.192,4.816-8.928,5.856-14.024H160z M104,144c-13.232,0-24-10.768-24-24
             s10.768-24,24-24s24,10.768,24,24S117.232,144,104,144z"/>
           <polygon points="244.28,80 272,80 272,64 235.72,64 203.72,112 176,112 176,128 212.28,128 			"/>
           <rect x="288" y="64" width="32" height="16"/>
           <path style={{ fill: "currentColor" }} d="M224,144h-48v48h48V144z M208,176h-16v-16h16V176z"/>
           <rect x="240" y="160" width="32" height="16"/>
           <rect x="288" y="160" width="32" height="16"/>
         </g>
       </g>
     </g>
     </svg>),
      title: "Training with Work Experience",
      description:
        "You will train with an Equity Research firm as an Analyst, gaining one year of valuable experience to become a highly attractive Financial Analyst candidate.",
    },
  ];

  export default features;